// removed by extract-text-webpack-plugin
module.exports = {"base":"_1w7Kp","searchIcon":"muf3b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/components/TextInput/icon.scss
// module id = 1933
// module chunks = 0